import { useMonthlyRawMaterialRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetMonthlyRawMaterialCommonInfoQuery } from "../../features/api/monthlyRawMaterialApi";

export { useMonthlyRawMaterialRoutes };

interface MonthlyRawMaterialsProps {
    isCumulative: boolean;
}

const MonthlyRawMaterials = ({ isCumulative }: MonthlyRawMaterialsProps) => {
  let title = isCumulative ? "مواد اولیه ماهانه تجمعی" : "مواد اولیه ماهانه";
  

  return GetDefaultIndex({
    title: title,
    query: useGetMonthlyRawMaterialCommonInfoQuery,
    queryArgs: isCumulative
  })();
};

export default MonthlyRawMaterials;